import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Modal,
  Button
} from "react-bootstrap";
import { useFormik } from 'formik';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import {
  planActions, subscriptionActions,
} from '../../actions';

const AddSubscription = ({ userId }) => {
  const dispatch = useDispatch();
  const plans = useSelector(state => state.plan.plans);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!plans.length) {
      dispatch(planActions.getAll());
    }
  }, [dispatch, plans.length]);

  const plansDetails = useMemo(() => (
    _.sortBy(
      plans.filter(plan => !plan.amount),
      ['interval', 'intervalCount'],
    ).map(plan => ({
      id: plan._id,
      name: `${plan.intervalCount} ${_.capitalize(plan.interval)}`,
    }))
  ), [plans]);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      userId,
      plan: '',
    },
    onSubmit: values => {
      // console.log('val', values);
      dispatch(subscriptionActions.addSubscription(values));
      handleClose();
    },

  });

  const handleClose = () => {
    setShow(false);
  }

  return (
    <>
      <Button disabled={!userId} onClick={() => setShow(true)}>
        Add Subscription
      </Button>
      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Subscription</Modal.Title>
        </Modal.Header>
        <form id="form" onSubmit={formik.handleSubmit}>
          <Modal.Body>
            <Row>
              <Col>
                <span>Plan:</span>
                <select id="plan" name="plan" value={formik.values.plan} onChange={formik.handleChange}>
                  <option value="" hidden>---</option>
                  {plansDetails.map(plan =>
                    <option value={plan.id} key={plan.id}>{`${plan.name} Free`}</option>
                  )}
                </select>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleClose}>Cancel</Button>
            <Button
              disabled={!formik.values.plan || !userId}
              type="submit"
              variant="primary"
            >
              Add
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
}

AddSubscription.propTypes = {
  userId: PropTypes.string,
};

AddSubscription.defaultProps = {
  userId: '',
};

export default AddSubscription;
